$(document).on("click", ".cart__qty .add-engrave", function () {
 let engraveinputs = $(".add-engrave-input");
  let engraved_id1 = $("#engraveId").val();
  let allEngraveQnty = 0;
  for (var i = 0; i < engraveinputs.length; i++) {
    allEngraveQnty = Number($(engraveinputs[i]).val()) + Number(allEngraveQnty);
  }
  if (engraved_id1) {
    setTimeout(function () {
      $.ajax({
        url: "/cart/change.js",
        type: "POST",
        data: { id: engraved_id1, quantity: allEngraveQnty },
        dataType: "json",
        success: function (data) {
          $("#engraveQuantity").val(allEngraveQnty);
          $(".engrave-hide-input").val(allEngraveQnty);
          $(".engrave-hide-input").attr("data-quantity-item", allEngraveQnty);
          $(".engrave-p-title").text("(x"+allEngraveQnty+")");
           
        },
        error: function (error) {
          console.log(error);
        },
      });
    }, 300);
  }
});

$(document).on("blur", ".add-engrave-input", function () {
  let engraveinputs = $(".add-engrave-input");
  let engraved_id1 = $("#engraveId").val();
  let allEngraveQnty = 0;
  for (var i = 0; i < engraveinputs.length; i++) {
    allEngraveQnty = Number($(engraveinputs[i]).val()) + Number(allEngraveQnty);
  }
  if (engraved_id1) {
    setTimeout(function () {
      $.ajax({
        url: "/cart/change.js",
        type: "POST",
        data: { id: engraved_id1, quantity: allEngraveQnty },
        dataType: "json",
        success: function (data) {
          $("#engraveQuantity").val(allEngraveQnty);
          $(".engrave-hide-input").val(allEngraveQnty);
          $(".engrave-hide-input").attr("data-quantity-item", allEngraveQnty);
          $(".engrave-p-title").text("(x"+allEngraveQnty+")");
           
        },
        error: function (error) {
          console.log(error);
        },
      });
    }, 300);
  }
});
